module.exports = __webpack_public_path__ + "img/7f4f9ce1f033ffaca189e9e56eba6292.b31cad2a.png";